import { useLocation } from "@tanstack/react-router";

import { BOOK_A_CALL_LINK } from "components/account_management/utils";
import Button from "components/ui/button/Button";
import { ExternalLink } from "lib/icons/ExternalLink";
import { white } from "lib/themes/colors";

import css from "./GuestPassRetiredPage.module.scss";

import TIME_ICON from "../../../assets/images/icons/time.svg";

type GuestLinkProfile = { kind: "buyer" | "supplier"; id: string };

/**
 * The profile an old guest-pass link pointed at. Links carried a guid or a numeric id; the profile
 * routes resolve either.
 */
export function guestLinkProfile(pathname: string): GuestLinkProfile | null {
  const match = /^\/guest_access\/(buyers|suppliers)\/([\w-]+)/.exec(pathname);
  if (!match) return null;
  return { kind: match[1] === "buyers" ? "buyer" : "supplier", id: match[2] };
}

export function GuestPassRetiredPage() {
  const { pathname } = useLocation();
  const profile = guestLinkProfile(pathname);

  return (
    <div className={css.container}>
      <img height={150} width={250} src={TIME_ICON} alt="time-icon" />
      <h1>This link is no longer available</h1>
      <div className={css.textContainer}>
        <p>
          Guest passes have been retired, so this link no longer opens a profile. To see this buyer
          or supplier in Stotles, book a call with our sales team.
        </p>
      </div>

      <div className={css.btnContainer}>
        {profile && (
          // A full page load: Rails sends a visitor without a session to log in, then back here.
          <Button as="a" buttonType="secondary" href={`/${profile.kind}s/${profile.id}`}>
            Log in to view this {profile.kind}
          </Button>
        )}
        <Button
          as="a"
          className={css.btn}
          href={BOOK_A_CALL_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ExternalLink fill={white} className={css.link} />
          Book a call
        </Button>
      </div>
    </div>
  );
}
